import { useState, useEffect } from 'react'
import { getChannel } from '../api'
import { message } from 'antd'

// 获取渠道的hook
// id	id	int	否	
// channel_type
// 类型	int	否	
// channel_name
// 名字	string	否	
// channel_account	渠道账号	string	否	
// channel_password	渠道密码	string	否	
// page_no	当前页	int	是	
// page_size	每页页数	int	是	

export default function useChannels({ page_no = 1, page_size = 10, ...params }) {
    const [channels, setChannels] = useState([])

    useEffect(() => {
        getChannel({
            page_no,
            page_size,
            ...params
        }).then(res => {
            const { code, data, msg } = res
            if (code === 0) {
                const { channel_list: list } = data

                // 过滤掉channel_data.type 是 1的 活动， 活动不是渠道
                setChannels(list.filter(item => !(item.channel_data && item.channel_data.type && item.channel_data.type === '1')))
            } else {
                message.error(msg)
            }
        }).catch(console.log)

    }, [page_no, page_size, ...Object.values(params)]);


    return [channels]
}

